import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loading } from "@/components/common";
import Layout from "@/components/Layout";
import TermsGate from "@/components/TermsGate";
import { homeFor } from "@/config";
import { rememberReturn } from "@/lib/returnTo";

export default function Protected({ roles, children, bare }) {
  const { user, ready } = useAuth();
  const location = useLocation();
  if (!ready) return <div className="min-h-screen grid place-items-center"><Loading /></div>;
  if (!user) {
    rememberReturn(location.pathname + location.search);  // signing in comes back here (Login.jsx)
    return <Navigate to="/login" replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={homeFor(user.role)} replace />;
  }
  if (user.terms_required) return <TermsGate />;  // updated terms come first (backend legal.terms_outdated)
  if (bare) return children;
  return <Layout>{children}</Layout>;
}
